import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";

const featured = dramas.filter((drama) => ["nanny", "fog-trace", "city-love"].includes(drama.id));

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % featured.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  function go(next: number) {
    setIndex((next + featured.length) % featured.length);
  }

  const current = featured[index];

  return (
    <section className="relative h-[420px] w-full overflow-hidden md:h-[560px]">
      {featured.map((drama, i) => (
        <div
          key={drama.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={drama.banner}
            alt={`${drama.title} 宣传剧照`}
            title={`${drama.title} 精彩剧照`}
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20"></div>
        </div>
      ))}

      <div className="relative z-10 mx-auto flex h-full w-full max-w-7xl flex-col justify-center px-4 md:px-6 lg:px-8">
        <div key={current.id} className="max-w-xl animate-fade-up">
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-primary-950">
            <i className="ri-fire-line"></i>
            首页焦点推荐
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-background-50 md:text-5xl">{current.title}</h2>
          <p className="mt-3 text-sm text-background-200 md:text-base">{current.subtitle}</p>
          <p className="mt-4 line-clamp-3 text-sm leading-relaxed text-background-200/90 md:line-clamp-2">
            {current.synopsis}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${current.id}`}
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-fill"></i>
              查看剧集详情
            </Link>
            <Link
              to="/category"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-apps-2-line"></i>
              浏览全部剧集
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(index - 1)}
        className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-foreground-950/40 text-background-50 transition-colors hover:bg-primary-500 md:left-6 md:h-11 md:w-11"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(index + 1)}
        className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-foreground-950/40 text-background-50 transition-colors hover:bg-primary-500 md:right-6 md:h-11 md:w-11"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 gap-2">
        {featured.map((drama, i) => (
          <button
            key={drama.id}
            type="button"
            aria-label={`切换到 ${drama.title}`}
            onClick={() => setIndex(i)}
            className={`h-2 cursor-pointer rounded-full transition-all ${
              i === index ? "w-6 bg-accent-500" : "w-2 bg-background-50/60"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}